import i18next from 'i18next';

i18next.addResources('es', 'ContactModal', {
  contactTherapist: 'Contactar terapeuta',
  copiedField: '{{copiedField}} copiado',
  phone: 'Teléfono',
  email: 'Mail'
});
